'use client';

import { PropsWithChildren } from 'react';

type OrderFormDesktopContainerProps = PropsWithChildren & { outcomesCount: number };

export const OrderFormDesktopContainer = ({ children }: OrderFormDesktopContainerProps) => {
  return (
    <div
      className="flex w-full flex-col gap-6 rounded-[16px] bg-v2-surface-secondary p-6"
      style={{ boxShadow: '0 0 20px 0 rgba(0, 41, 98, 0.1)' }}
    >
      {children}
    </div>
  );
};
